import { render, staticRenderFns } from "./CallbotClientSidebar.vue?vue&type=template&id=70110791&scoped=true"
import script from "./CallbotClientSidebar.vue?vue&type=script&lang=ts"
export * from "./CallbotClientSidebar.vue?vue&type=script&lang=ts"
import style0 from "./CallbotClientSidebar.vue?vue&type=style&index=0&id=70110791&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70110791",
  null
  
)

export default component.exports